export const Color = {
    white: "#FFFFFF",
    main: "#FF7F50",
    text: "#4F2F2F",
  };